import React, { useEffect, useState } from "react";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle,
    IconButton, useTheme,
    Box,
    Typography,
    Grid, Autocomplete
} from "@mui/material";

import { Edit, Delete } from "@mui/icons-material";
import { tokens } from "../../theme/theme";
import useCostingCategories from "../../hooks/useCostingCategories";
import ResponsiveBox from "../../Layout/ResponsiveScrollBox";
import { ResponsivePie } from "@nivo/pie";




function CostingModule() {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { costCategories, setCostCategories, loadCostCategorySelection, } = useCostingCategories();
    const [categories, setCategories] = useState([]);
    const [predefinedItems, setpredefinedItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);  // New State for Edit Mode
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [editItemId, setEditItemId] = useState(null);  // Track item being edited
    const [formData, setFormData] = useState({ item_name: "", unit_cost: "", quantity: "" });



    const [selectedSubItemId, setSelectedSubItemId] = useState(null);



    useEffect(() => {
        if (costCategories && costCategories.length > 0 && costCategories !== 'undefined') {
            const parseData = (data) => typeof data === 'string' ? JSON.parse(data) : data;

            const mapRows = (dataList) => {
                return dataList.reduce((acc, item) => {
                    const {
                        id_costing_category,
                        description,
                        item_id,
                        item_name,
                        id_sub_item,
                        sub_item,
                        unit_cost,
                        quantity
                    } = item;

                    // 1. Find or create category group
                    let categoryGroup = acc.find(cat => cat.id === id_costing_category);
                    if (!categoryGroup) {
                        categoryGroup = {
                            id: id_costing_category,
                            name: description,
                            items: []
                        };
                        acc.push(categoryGroup);
                    }

                    // 2. Find or create item group inside category
                    let itemGroup = categoryGroup.items.find(i => i.id === item_id);
                    if (!itemGroup) {
                        itemGroup = {
                            id: item_id,
                            item_name,
                            sub_items: []
                        };
                        categoryGroup.items.push(itemGroup);
                    }

                    // 3. Add sub_item to itemGroup
                    if (id_sub_item && sub_item) {
                        const subItemExists = itemGroup.sub_items.find(s => s.id === id_sub_item);
                        if (!subItemExists) {
                            itemGroup.sub_items.push({
                                id: id_sub_item,
                                name: sub_item,
                                unit_cost: unit_cost || 0,
                                quantity: quantity || 0,
                            });
                        }
                    }

                    return acc;
                }, []);
            };

            const productData = parseData(costCategories);
            setCategories(Array.isArray(productData) ? mapRows(productData) : []);

            // Optional: flat structure of predefined items
            const generatePredefinedItems = (dataList) => {
                return dataList.reduce((acc, item) => {
                    const { description, item_id, item_name } = item;
                    if (!acc[description]) acc[description] = [];

                    if (!acc[description].some(i => i.id === item_id)) {
                        acc[description].push({
                            id: item_id,
                            item_name
                        });
                    }

                    return acc;
                }, {});
            };

            const predefinedItems = generatePredefinedItems(productData);
            setpredefinedItems(predefinedItems);
        }
    }, [costCategories, setCostCategories]);



    const handleOpen = (categoryId, item = null) => {
        setSelectedCategoryId(categoryId);
        if (item) {
            setEditMode(true);
            setEditItemId(item.id);
            setFormData(item);
        } else {
            setEditMode(false);
            setFormData({ item_name: "", unit_cost: "", quantity: "" });
        }
        setOpen(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // sub item values
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [editSubItemId, setEditSubItemId] = useState(null);

    const handleOpenSubItem = (categoryId, itemId, subItem = null) => {
        setSelectedCategoryId(categoryId);
        setSelectedItemId(itemId);
        setSelectedSubItemId(subItem.id);
        if (subItem) {
            setEditMode(true);
            setEditSubItemId(subItem.id);
            setFormData({
                name: subItem.name,
                unit_cost: subItem.unit_cost,
                quantity: subItem.quantity,
            });
        } else {
            setEditMode(false);
            setEditSubItemId(null);
            setFormData({ name: "", unit_cost: "", quantity: "" });
        }
        setOpen(true);
    };


    const handleDeleteSubItem = (categoryId, itemId, subItemId) => {
        const updatedCategories = categories.map((category) => {
            if (category.id === categoryId) {
                return {
                    ...category,
                    items: category.items.map((item) => {
                        if (item.id === itemId) {
                            return {
                                ...item,
                                sub_items: item.sub_items.filter(
                                    (subItem) => subItem.id !== subItemId
                                ),
                            };
                        }
                        return item;
                    }),
                };
            }
            return category;
        });

        setCategories(updatedCategories);
    };

    // const handleSaveSubItem = () => {
    //     const updatedCategories = categories.map((category) => {
    //         if (category.id === selectedCategoryId) {
    //             return {
    //                 ...category,
    //                 items: category.items.map((item) => {
    //                     if (item.id === selectedItemId) {
    //                         const updatedSubItems = item.sub_items.map((subItem) => {
    //                             if (subItem.id === editSubItemId) {
    //                                 return {
    //                                     ...subItem,
    //                                     name: formData.name,
    //                                     unit_cost: parseFloat(formData.unit_cost),
    //                                     quantity: parseFloat(formData.quantity),
    //                                 };
    //                             }
    //                             return subItem;
    //                         });

    //                         return {
    //                             ...item,
    //                             sub_items: updatedSubItems,
    //                         };
    //                     }
    //                     return item;
    //                 }),
    //             };
    //         }
    //         return category;
    //     });

    //     setCategories(updatedCategories);
    //     handleClose();
    // };

    const handleSaveSubItem = () => {
        if (!selectedCategoryId || !selectedItemId || !formData.name) return;

        setCategories(prev => {
            return prev.map(category => {
                if (category.id !== selectedCategoryId) return category;

                return {
                    ...category,
                    items: category.items.map(item => {
                        if (item.id !== selectedItemId) return item;

                        let updatedSubItems = item.sub_items ? [...item.sub_items] : [];

                        if (editMode && selectedSubItemId) {
                            // Update specific sub-item by ID
                            updatedSubItems = updatedSubItems.map(sub => {
                                if (sub.id === selectedSubItemId) {
                                    return {
                                        ...sub,
                                        name: formData.name,
                                        unit_cost: parseFloat(formData.unit_cost),
                                        quantity: parseFloat(formData.quantity),
                                    };
                                }
                                return sub;
                            });
                        } else {
                            // Check for existing sub-item with the same name
                            const existingIndex = updatedSubItems.findIndex(
                                sub => sub.name.trim().toLowerCase() === formData.name.trim().toLowerCase()
                            );

                            if (existingIndex !== -1) {
                                // Sub-item already exists → update unit_cost & quantity only
                                updatedSubItems[existingIndex] = {
                                    ...updatedSubItems[existingIndex],
                                    unit_cost: parseFloat(formData.unit_cost),
                                    quantity: parseFloat(formData.quantity),
                                };
                            } else {
                                // Sub-item does not exist → add new one
                                const newSubItem = {
                                    id_sub_item: Date.now(),
                                    name: formData.name.trim(),
                                    unit_cost: parseFloat(formData.unit_cost),
                                    quantity: parseFloat(formData.quantity),
                                };
                                updatedSubItems.push(newSubItem);
                            }
                        }

                        return {
                            ...item,
                            sub_items: updatedSubItems,
                        };
                    }),
                };
            });
        });

        // Reset state & close dialog
        setFormData({ name: "", unit_cost: "", quantity: "" });
        setSelectedItemId(null);
        setSelectedSubItemId(null);
        setSelectedCategoryId(null);
        setEditMode(false);
        setOpen(false);
    };


    const handleClose = () => {
        setOpen(false);
        setEditMode(false);
        setEditSubItemId(null);
        setFormData({ name: "", unit_cost: "", quantity: "" });
    };

    const calculateSubtotal = (items) => {
        return items.reduce((acc, item) => {
            const itemTotal = (item.sub_items || []).reduce((subAcc, subItem) => {
                return subAcc + (parseFloat(subItem.unit_cost) || 0) * (parseFloat(subItem.quantity) || 0);
            }, 0);
            return acc + itemTotal;
        }, 0);
    };

    const calculateTotalCost = () => {
        return categories.reduce((acc, category) => acc + calculateSubtotal(category.items), 0);
    };



    // pie chart 
    const getPieChartData = (categories) => {
        return categories
            .filter(category => calculateSubtotal(category.items) > 0) // Only include categories with a cost
            .map(category => ({
                id: category.name,
                label: category.name,
                value: calculateSubtotal(category.items),
            }));
    };

    return (
        <Box m={2}>
            {/* <CustomTableContainer colors={colors}> */}
            <ResponsiveBox
                customMaxHeight={{
                    xs: '72vh', // Extra small devices (phones)
                    sm: '72vh', // Small devices (tablets)
                    md: '70vh', // Medium devices (small laptops)
                    lg: '80vh', // Large devices (desktops)
                    xl: '86vh', // Extra large devices (large desktops)
                }}>

                <Grid container gap={1}>
                    <Grid item lg={7.7}>
                        <Box sx={{ backgroundColor: "#b3e5fc", borderRadius: "10px" }}>
                            <Box gridColumn="span 9"
                                gridRow="span 2"
                                alignItems="center"
                                justifyContent="center"
                                padding={1} // Reduced padding for a tighter layout
                                sx={{
                                    "& .MuiTable-root": {
                                        border: "none",
                                        size: "small", // Compact table
                                    },
                                    "& .MuiTableCell-root": {
                                        borderBottom: "none",
                                        padding: "2px", // Tighter padding for cells
                                        fontSize: "14px", // Reduced font size for compactness
                                    },
                                    "& .name-column--cell": {
                                        color: colors.greenAccent[300],
                                        padding: "1px", // Further reduced padding for name column cells
                                    },
                                    "& .MuiTableHead-root": {
                                        borderBottom: "none",
                                    },
                                    "& .MuiTableBody-root": {
                                        overflowY: "auto",
                                    },
                                    "& .MuiCheckbox-root": {
                                        color: `${colors.blueAccent[200]} !important`,
                                        size: "small", // Reduced checkbox size
                                        padding: "1px", // Minimal padding around checkboxes
                                    },
                                    "& .MuiTableFooter-root": {
                                        borderTop: "none",
                                        backgroundColor: colors.blueAccent[700],
                                        height: "6px", // Slightly reduced footer height
                                    },
                                    "& .MuiButton-text": {
                                        color: `${colors.grey[100]} !important`,
                                        fontSize: "12px", // Smaller button text for uniformity
                                    },

                                }}>
                                <TableContainer sx={{ backgroundColor: "#e1f5fe", color: "black" }} >

                                    <Box padding={1} sx={{ backgroundColor: "#01579b", color: "white", display: "flex", alignItems: "center", gap: 2 }}>
                                        <Typography sx={{ fontWeight: "bold", fontSize: "18px", marginBottom: "8px" }}>
                                            COST SHEET
                                        </Typography>

                                        {/* Month Selection */}
                                        <input
                                            type="month"
                                            style={{
                                                padding: "2px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                            }}
                                        />
                                    </Box>


                                    <Table>
                                        <TableHead>
                                            < TableRow sx={{ backgroundColor: "#e1f5fe" }}>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>CATEGORY</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>ITEM NAME</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>UNIT COST (₹)</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>QUANTITY</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>TOTAL COST (₹)</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>ACTIONS</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {categories.map((category) => (
                                                <React.Fragment key={category.id}>
                                                    <TableRow sx={{ backgroundColor: "#4fc3f7", fontWeight: "bold" }}>
                                                        <TableCell colSpan={6} sx={{ color: "black" }}>{category.name}</TableCell>
                                                    </TableRow>


                                                    {category.items.map((item, itemIndex) => (
                                                        <React.Fragment key={item.id}>
                                                            <TableRow sx={{ backgroundColor: itemIndex % 2 === 0 ? "#b3e5fc" : "#81d4fa" }}>
                                                                <TableCell sx={{ color: "black" }}></TableCell>
                                                                <TableCell sx={{ color: "black", fontWeight: "bold" }}>{item.item_name}</TableCell>
                                                                <TableCell />
                                                                <TableCell />
                                                                <TableCell />
                                                                <TableCell />
                                                            </TableRow>

                                                            {item.sub_items &&
                                                                item.sub_items
                                                                    .filter((subItem) => parseFloat(subItem.quantity) !== 0) // 👈 Filter out zero quantity
                                                                    .map((subItem, subIndex) => (
                                                                        <TableRow key={subItem.id_sub_item} sx={{ backgroundColor: subIndex % 2 === 0 ? "#e1f5fe" : "#b3e5fc" }}>
                                                                            <TableCell />
                                                                            <TableCell sx={{ paddingLeft: 4, color: "black" }}>↳ {subItem.name}</TableCell>
                                                                            <TableCell sx={{ color: "black" }}>{subItem.unit_cost}</TableCell>
                                                                            <TableCell sx={{ color: "black" }}>{subItem.quantity}</TableCell>
                                                                            <TableCell sx={{ color: "black" }}>
                                                                                {(subItem.unit_cost * subItem.quantity).toFixed(2)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <IconButton onClick={() => handleOpenSubItem(category.id, item.id, subItem)} >
                                                                                    <Edit sx={{ fontSize: "14px", color: "black" }} />
                                                                                </IconButton>
                                                                                <IconButton onClick={() => handleDeleteSubItem(category.id, item.id, subItem.id)} >
                                                                                    <Delete sx={{ fontSize: "14px", color: "black" }} />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}

                                                        </React.Fragment>
                                                    ))}

                                                    <TableRow sx={{ backgroundColor: "#b3e5fc", fontWeight: "bold" }}>
                                                        <TableCell colSpan={4} sx={{ color: "black" }}><strong>Subtotal for {category.name}</strong></TableCell>
                                                        <TableCell sx={{ color: "black" }}><strong>₹{calculateSubtotal(category.items).toFixed(2)}</strong></TableCell>
                                                        <TableCell></TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            ))}
                                            <TableRow sx={{ backgroundColor: "#01579b", fontWeight: "bold" }}>
                                                <TableCell colSpan={4} sx={{ color: "white" }}><strong>Total Production Cost</strong></TableCell>
                                                <TableCell sx={{ color: "white" }}><strong>₹{calculateTotalCost().toFixed(2)}</strong></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item lg={3.8}>
                        <Box style={{ width: '600px', height: '400px', Padding: "5px", backgroundColor: "#e1f5fe", borderRadius: "5px" }}>
                            <ResponsivePie

                                data={getPieChartData(categories)}
                                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                                innerRadius={0.5}
                                padAngle={0.7}
                                cornerRadius={3}
                                colors={{ scheme: 'category10' }}
                                borderWidth={1}
                                borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                                radialLabelsSkipAngle={10}
                                radialLabelsTextXOffset={6}
                                radialLabelsTextColor="#333333"
                                radialLabelsLinkColor={{ from: 'color' }}
                                slicesLabelsSkipAngle={10}
                                slicesLabelsTextColor="#333333"
                                animate={true}
                                padding={1}
                            />
                        </Box>
                    </Grid>
                </Grid>

            </ResponsiveBox>
            <Box marginTop={0.4} sx={{ backgroundColor: colors.primary[400], fontWeight: "bold" }}>
                {categories.map((category) => (
                    <Button key={category.id} variant="contained" color="secondary" onClick={() => handleOpen(category.id)} style={{ margin: "10px" }}>
                        Add Item to {category.name}
                    </Button>
                ))}
            </Box>

            <Dialog open={open} onClose={handleClose}
                fullWidth
                maxWidth="sm" >
                <DialogTitle>
                    {editMode
                        ? selectedItemId !== null
                            ? "Edit Sub-Item"
                            : "Edit Item"
                        : selectedItemId !== null
                            ? "Add Sub-Item"
                            : "Add Item"}
                </DialogTitle>


                <DialogContent>



                    {/* Category selection */}
                    <Autocomplete
                        fullWidth
                        options={categories}
                        getOptionLabel={(option) => option.name}
                        value={categories.find(c => c.id === selectedCategoryId) || null}
                        onChange={(e, newValue) => {
                            setSelectedCategoryId(newValue?.id || null);
                            setSelectedItemId(null);
                            setSelectedSubItemId(null);
                            setFormData({ name: "", unit_cost: "", quantity: "" });
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Category" fullWidth sx={{ mt: 1 }} />
                        )}
                    />

                    {/* Item selection */}
                    {selectedCategoryId && (
                        <Autocomplete
                            fullWidth
                            options={categories.find(c => c.id === selectedCategoryId)?.items || []}
                            getOptionLabel={(option) => option.item_name}
                            value={
                                categories
                                    .find(c => c.id === selectedCategoryId)
                                    ?.items.find(item => item.id === selectedItemId) || null
                            }
                            onChange={(e, newValue) => {
                                setSelectedItemId(newValue?.id || null);
                                setSelectedSubItemId(null);
                                setFormData({ name: "", unit_cost: "", quantity: "" });
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Item" fullWidth sx={{ mt: 2 }} />
                            )}
                        />
                    )}

                    {/* Sub-Item selection */}
                    {selectedItemId && (
                        <Autocomplete
                            fullWidth
                            options={
                                categories
                                    .find(c => c.id === selectedCategoryId)
                                    ?.items.find(i => i.id === selectedItemId)
                                    ?.sub_items || []
                            }
                            getOptionLabel={(option) => option.name}
                            value={
                                categories
                                    .find(c => c.id === selectedCategoryId)
                                    ?.items.find(i => i.id === selectedItemId)
                                    ?.sub_items.find(sub => sub.id === selectedSubItemId) || null
                            }
                            onChange={(e, newValue) => {
                                setSelectedSubItemId(newValue?.id || null);
                                setFormData({
                                    name: newValue?.name || "",
                                    unit_cost: newValue?.unit_cost || "",
                                    quantity: newValue?.quantity || "",
                                });
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Sub-Item" fullWidth sx={{ mt: 2 }} />
                            )}
                        />
                    )}

                    {/* Editable fields (optional) */}
                    {selectedSubItemId && (
                        <>
                            <TextField
                                label="Unit Cost (₹)"
                                name="unit_cost"
                                type="number"
                                value={formData.unit_cost}
                                onChange={handleChange}
                                fullWidth
                                sx={{ mt: 2 }}
                            />
                            <TextField
                                label="Quantity"
                                name="quantity"
                                type="number"
                                value={formData.quantity}
                                onChange={handleChange}
                                fullWidth
                                sx={{ mt: 2 }}
                            />
                        </>
                    )}

                </DialogContent>



                <DialogActions>
                    <Button variant="contained" onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSaveSubItem}
                        color="secondary"
                    >
                        {editMode ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box >

    );
}

export default CostingModule;